import bowser from "bowser";

const useBrowserDetection = () => {
  const browser = bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  const browserVersion = browser.getBrowserVersion();
  const isLegacySafari = browserName === "Safari" && parseFloat(browserVersion ?? "0") < 17.4;
  const supportsPromiseWithResolvers = typeof Promise.withResolvers === "function";

  return { browserName, browserVersion, isLegacySafari, supportsPromiseWithResolvers };
};

export { useBrowserDetection };
